import React from 'react';
import {getAllSkills, getStatColor} from '../../utils/helpers';
import SectionHeader from '../ui/SectionHeader';
import RACES from '../../data/races';
import SKILLS from '../../data/skills';

import { PERKS_FROM_RACE } from '../../config/gameConfig';

// ─── STEP 2: PERKS ──────────────────────────────────────────────────────────
function PerkStep({ character, setCharacter }) {
  const race = RACES.find(r => r.id === character.race);
  const allSkills = getAllSkills();

  function toggleRacePerk(idx) {
    let sel = [...character.selectedPerks];
    if (sel.includes(idx)) {
      sel = sel.filter(i => i !== idx);
    } else {
      if (sel.length >= PERKS_FROM_RACE) return;
      sel.push(idx);
    }
    setCharacter({ ...character, selectedPerks: sel });
  }

  // For the free perk dropdown, exclude skills already chosen as race perks
  // (perks are skill names, free perk is a skill id — we match by name)
  const racePerkSkillNames = character.selectedPerks.map(i => race.perks[i]);

  return (
    <div>
      <SectionHeader>Choose Perks</SectionHeader>
      <p style={{ fontSize: "13px", color: "#8a7e5e", marginBottom: 18, lineHeight: 1.5 }}>
        Select <strong style={{ color: "#c9a84c" }}>2 of 3</strong> race perks, then choose <strong style={{ color: "#8e44ad" }}>1 free perk</strong> — any skill you like. All perks grant <strong style={{ color: "#c9a84c" }}>+2</strong> to that skill.
      </p>
      {/* Race Perks */}
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: "'Cinzel', serif", fontSize: "11px", color: "#8a7e5e", letterSpacing: 1, textTransform: "uppercase", marginBottom: 10 }}>Race Perks — {race.name} (pick 2)</div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          {race.perks.map((perk, idx) => {
            const isSelected = character.selectedPerks.includes(idx);
            return (
              <button key={idx} onClick={() => toggleRacePerk(idx)}
                style={{
                  background: isSelected ? "linear-gradient(180deg, #2a1f0e, #1a1510)" : "rgba(20,16,10,0.5)",
                  border: isSelected ? "1px solid #c9a84c" : "1px solid rgba(201,168,76,0.2)",
                  borderRadius: 8, padding: "12px 18px", cursor: "pointer", transition: "all 0.2s", color: "#e8dcc8"
                }}>
                <div style={{ fontFamily: "'Cinzel', serif", fontSize: "13px", color: isSelected ? "#c9a84c" : "#a08d4e" }}>{perk}</div>
                <div style={{ fontSize: "10px", color: "#6b6048", marginTop: 3 }}>+2 bonus</div>
              </button>
            );
          })}
        </div>
      </div>
      {/* Free Perk */}
      <div>
        <div style={{ fontFamily: "'Cinzel', serif", fontSize: "11px", color: "#8e44ad", letterSpacing: 1, textTransform: "uppercase", marginBottom: 10 }}>Free Perk — Any Skill</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: "6px" }}>
          {["might","speed","intellect"].map(statId => (
            <div key={statId}>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: "9px", color: getStatColor(statId), letterSpacing: 1, textTransform: "uppercase", marginBottom: 4, marginTop: statId !== "might" ? 8 : 0 }}>{statId}</div>
              {SKILLS[statId].map(skill => {
                const isChosen = character.freePerk === skill.id;
                return (
                  <button key={skill.id} onClick={() => setCharacter({ ...character, freePerk: isChosen ? null : skill.id })}
                    style={{
                      display: "block", width: "100%", textAlign: "left", background: isChosen ? "rgba(142,68,173,0.2)" : "rgba(20,16,10,0.4)",
                      border: isChosen ? "1px solid #8e44ad" : "1px solid rgba(201,168,76,0.1)",
                      borderRadius: 4, padding: "5px 10px", cursor: "pointer", color: isChosen ? "#c39bd3" : "#a09070", fontSize: "12px",
                      fontFamily: "'Palatino Linotype', serif", marginBottom: 2, transition: "all 0.15s"
                    }}>
                    {skill.name} {isChosen && <span style={{ color: "#8e44ad" }}>✓</span>}
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PerkStep
